import { useContext, useEffect, lazy, Suspense } from 'react'
import { UIView, useRouter, useCurrentStateAndParams } from '@uirouter/react'
import AuthContext from '../../authService/Context'
import LoadingUser from './LoadingUser'
import last from 'lodash/last'
import get from 'lodash/get'

const RolesNotFound = lazy(() => import('./RolesNotFound'))
const StatusNotActive = lazy(() => import('./StatusNotActive'))
const LoginPage = lazy(() => import('./LoginPage'))
const ForgotPasswordPage = lazy(() => import('./ForgotPasswordPage'))
const RegisterPage = lazy(() => import('./RegisterPage'))
const Layout = lazy(() => import('../../layout'))

export default function Init() {
  const { user, getting } = useContext(AuthContext)
  const router = useRouter()
  const { state } = useCurrentStateAndParams()
  const { roles, isAuthenticated, status } = user
  const currentStateName = state?.name
  const { stateService } = router

  useEffect(() => {
    if (!isAuthenticated) {
      if (!currentStateName || currentStateName === 'App' || currentStateName.startsWith('App.')) {
        stateService.go('App')
      }

      return
    }

    if (currentStateName === 'forgotPassword' || currentStateName === 'register') {
      stateService.go('App.Dashboard')
      return
    }

    const currentView = last(stateService.getCurrentPath())?.state?.name

    if (currentView === 'App') stateService.go('App.Dashboard')
  }, [currentStateName, isAuthenticated, stateService])

  if (getting) return <LoadingUser />

  if (isAuthenticated && (!roles || (Array.isArray(roles) && roles.length === 0))) {
    return (
      <Suspense fallback={<LoadingUser />}>
        <RolesNotFound />
      </Suspense>
    )
  }

  if (isAuthenticated && status && status !== 'ACTIVE'){
    return (
      <Suspense fallback={<LoadingUser/>}>
        <StatusNotActive/>
      </Suspense>
    )
  }

  let unauthenticatedView = <LoginPage />

  if (currentStateName === 'forgotPassword') {
    unauthenticatedView = <ForgotPasswordPage />
  } else if (currentStateName === 'register') {
    unauthenticatedView = <RegisterPage />
  }

  return (
    <Suspense fallback={<LoadingUser />}>
      {isAuthenticated ? (
        <Layout>
          <UIView name="main" />
        </Layout>
      ) : (
        unauthenticatedView
      )}
    </Suspense>
  )
}
